export class AiStrategyTrade {
    public id: string | undefined;
    public symbol: string | undefined;
    public isLong: boolean = false;
    public isOpen: boolean = false;
    public isNew: boolean = false;
    public isNewReenter: boolean = false;
    public entryTime: Date | undefined;
    public entryPrice: number | undefined;
    public exitTime: Date | undefined;
    public exitPrice: number | undefined;
    public exitReason: string | undefined;
    public stopPrice: number | undefined;
    public smartStop: number | undefined;
    public timeStop: Date | undefined;
    public lastPrice: number | undefined;
    public fullRiskProfit: number | undefined;
    public maxProfit: number | undefined;
    public maxProfitTime: Date | undefined;
    public minProfit: number | undefined;
    public minProfitTime: Date | undefined;
    public profitChange15: number | undefined;
    public profitChange5: number | undefined;
    public tradeZone: number = 0;
    public reenterTime: Date | undefined;
    public reenterPrice: number | undefined;
    public reenterStopPrice: number | undefined;
    public dataLastUpdated: Date | undefined;
    public segmentCode: string | undefined;
    public segmentName: string | undefined;
    public strategyName: string | undefined;
}